<template>
  <div>
    <md-subheader>
      <span class="md-headline" style=" text-transform: uppercase;"><b>{{ company }}</b></span>
    </md-subheader>
    <md-divider></md-divider>

    <md-tabs>
      <md-tab id="settings" :md-label="`Settings`" md-icon="settings" v-on:click="setVisible('settings')"></md-tab>
      <md-tab id="format_list_numbered" :md-label="`Automations`" md-icon="format_list_numbered"
        v-on:click="setVisible('automations')"></md-tab>
      <md-tab id="autonumbers" :md-label="`Autonumbers`" md-icon="pin" v-on:click="setVisible('autonumbers')"></md-tab>
    </md-tabs>
    <div v-if="visiblePanel == 'settings'">
      <form novalidate class="md-layout">
        <md-card class="md-layout-item md-size-50 md-small-size-100">
          <md-card-header>
            <div class="md-title">Shared Variables</div>
            <span class="md-caption">All set variables will be passed to your script during execution</span>
          </md-card-header>

          <md-button class="md-dense md-raised md-primary" @click="addSettingsPopup = true"
            :disabled="settingsBlocked">Add
            new variable</md-button>
          <md-button type="submit" class="md-raised md-dense md-accent" @click="saveSettings"
            :disabled="settingsBlocked || !unsavedSettings">Save</md-button>
          <md-card-content>
            <md-toolbar class="
            md-accent
            md-dense" v-if="unsavedSettings">
              <span class="md-subheading">You have unsaved changes</span>
            </md-toolbar>
            <md-field>
              <label>client_id</label>
              <md-input md-counter="64" :disabled="settingsBlocked" v-model="companySettings.client_id"></md-input>
            </md-field>
            <md-field>
              <label>client_secret</label>
              <md-input md-counter="64" :disabled="settingsBlocked" v-model="companySettings.client_secret"
                type="password"></md-input>
            </md-field>
            <md-field>
              <label>refresh_token</label>
              <md-input md-counter="64" :disabled="settingsBlocked" v-model="companySettings.refresh_token"
                type="password"></md-input>
              <md-icon class="pointer additional-margin" v-on:click.native="onRefreshDialogClick()">help_outline</md-icon>
            </md-field>

            <md-field v-for="setting in customSettings" v-bind:key="setting">
              <label>{{ setting }}</label>
              <md-input md-counter="1024" :disabled="settingsBlocked" type="password" v-model="companySettings[setting]">
              </md-input>
              <md-icon class="pointer additional-margin"
                v-on:click.native="deleteCustomSetting(setting)">delete_outline</md-icon>
            </md-field>
          </md-card-content>

          <md-progress-bar md-mode="indeterminate" v-if="settingsBlocked" />

          <md-card-actions>
          </md-card-actions>
          <p class="md-caption">&nbsp; &nbsp;More information regarding BeProduct OAuth2 and refreshing tokens can be
            found in <a href="https://python.beproduct.com/003-getting-refresh-token/" target="_blank">
              documentation
            </a></p>
        </md-card>

      </form>
    </div>
    <div v-if="visiblePanel == 'automations'">
      <md-card class="md-layout-item md-size-100 md-small-size-100">
        <md-card-header>
          <div class="md-title">Automations Management</div>
          <span class="md-caption">Create, Modify, Delete and Monitor your automations</span>
        </md-card-header>
        <md-card-content>
          <md-button class="md-dense md-layout-item md-raised" @click="fetchAutomations">Refresh list
          </md-button>
          <md-button class="md-dense md-layout-item md-raised md-primary" @click="addAutomation">New automation
          </md-button>
        </md-card-content>
        <md-field style="width:500px;margin:0 0 0 30px;">
          <label>Search by Automation ID, Name or Description</label>
          <md-input v-model="automationSearch"></md-input>
          <md-icon>search</md-icon>
        </md-field>

        <md-table md-sort="updated_on" md-sort-order="desc">
          <md-table-row>
            <md-table-head>
              Modify / Delete / Logs</md-table-head>
            <md-table-head>Automation ID</md-table-head>
            <md-table-head>Name</md-table-head>
            <md-table-head>Description</md-table-head>
            <md-table-head>Status</md-table-head>
            <!--md-table-head>Execution count</md-table-head-->
            <md-table-head>Created By</md-table-head>
            <md-table-head>Created On (UTC)</md-table-head>
            <md-table-head>Last Update By</md-table-head>
            <md-table-head>Last Update On (UTC)</md-table-head>
          </md-table-row>
          <md-table-row v-for="automation in foundAutomations" v-bind:key="automation.id">
            <md-table-cell>
              <md-button class="md-icon-button md-dense" @click="openEdit(automation.id)">
                <md-icon class="pointer">edit</md-icon>
              </md-button>
              <md-button class="md-icon-button md-dense"
                @click="automationToDelete = automation; deleteAutomationDialogShow = true">
                <md-icon>delete</md-icon>
              </md-button>
              <md-button class="
                md-icon-button
                md-dense" @click="openLog(automation.id)">
                <md-icon class="pointer">history</md-icon>
              </md-button>
            </md-table-cell>
            <md-table-cell>
              {{ automation.id }}
            </md-table-cell>
            <md-table-cell><b>{{ automation.name }}</b></md-table-cell>
            <md-table-cell><b>{{ automation.description.length < 64 ? automation.description :
              automation.description.slice(0, 64).concat('...') }}</b></md-table-cell>
            <md-table-cell>{{ automation.enabled ? 'Enabled' : 'Disabled' }}</md-table-cell>
            <!--md-table-cell>1023 <i>time(s)</i></md-table-cell-->
            <md-table-cell>{{ automation.created_by.fullname }}</md-table-cell>
            <md-table-cell>{{ automation.created_on }}</md-table-cell>
            <md-table-cell>{{ automation.updated_by.fullname }}</md-table-cell>
            <md-table-cell>{{ automation.updated_on }}</md-table-cell>
          </md-table-row>
        </md-table>
        <md-card-actions>
        </md-card-actions>
        <p class="md-caption">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Important notice:</b> Make sure your automations
          are fast and used for business logic only and not for data processing. In case of high cpu/memory/bandwidth
          usage all your automations may be blocked/disabled.</p>
        <br />
      </md-card>
    </div>
    <div v-if="visiblePanel == 'autonumbers'">
      <Autonumber />
    </div>
    <!--DIALOGS-->
    <md-dialog-prompt :md-active.sync="addSettingsPopup" v-model="newVariableName" md-title="Add New Share Variable"
      md-input-maxlength="64" md-input-placeholder="Type a variable name" md-confirm-text="Add new variable"
      v-on:md-confirm="addCustomSetting" />
    <md-dialog-alert :md-active.sync="errorDialogShow" :md-content="errorMsg" md-confirm-text="Ok" />
    <md-dialog-confirm :md-active.sync="refreshTokenDialogShow" md-title="Where do I get a refresh token?"
      md-content="If you don't have a refresh token yet just generate one right now. Make sure you have correct <b>client id</b> and <b>client secret</b> populated in the shared variables settings."
      md-confirm-text="Sure. Let's generate a new one!" md-cancel-text="Thanks but I already have one"
      @md-confirm="refreshToken" />

    <md-dialog :md-active.sync="deleteAutomationDialogShow" @md-confirm="deleteAutomation">
      <md-dialog-title>Delete Automation {{ automationToDelete.name }}?</md-dialog-title>
      <md-content>You are trying to delete automation <b>{{ automationToDelete.name }}</b>. This opertion is IRREVERSIBLE.
        Your code will be lost. Are you sure?</md-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="deleteAutomationDialogShow = false">CANCEL</md-button>
        <md-button class="md-accent" @click="deleteAutomation()" :disabled="deleteClicked">DELETE</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>
<script>
import axios from "axios";
import Autonumber from "./Autonumber";
const BASE_URL = process.env.VUE_APP_FUNCTIONURL;

export default {
  name: "Company",
  components: {
    Autonumber,
  },
  data: () => ({
    automations: [],
    company: "",
    defaultSettings: [
      "client_id",
      "client_secret",
      "refresh_token",
      "company_domain",
    ],
    companySettings: {},
    initialCompanySettings: {},
    settingsBlocked: true,
    visiblePanel: "settings",
    addSettingsPopup: false,
    newVariableName: "",
    errorMsg: "",
    errorDialogShow: false,
    refreshTokenDialogShow: false,
    deleteAutomationDialogShow: false,
    deleteClicked: false,
    automationToDelete: { name: null, id: null },
    automationSearch: "",
  }),
  created: function () {
    this.company = this.$route.params.company;
    this.callApi(
      `${BASE_URL}/api/settings?company=${this.company}`,
      null,
      (response) => {
        this.companySettings = response.data;
        this.initialCompanySettings = { ...response.data }; //JSON.parse(JSON.stringify(response.data)); // json clone
        this.settingsBlocked = false;
      },
      "Error happened while loading settings"
    );
    this.fetchAutomations();
  },

  computed: {
    customSettings() {
      return Object.keys(this.companySettings).filter(
        (i) => !this.defaultSettings.includes(i)
      );
    },
    unsavedSettings() {
      return (
        JSON.stringify(this.companySettings) !=
        JSON.stringify(this.initialCompanySettings)
      );
    },
    foundAutomations() {
      console.log(this.automations);
      return this.automations
        .filter(
          (a) =>
            a.id.toLowerCase().includes(this.automationSearch.toLowerCase()) ||
            a.name
              .toLowerCase()
              .includes(this.automationSearch.toLowerCase()) ||
            a.description
              .toLowerCase()
              .includes(this.automationSearch.toLowerCase())
        )
        .sort((a, b) => a.updated_on.localeCompare(b.updated_on) * -1);
    },
  },
  methods: {
    callApi(url, body, success, errMsg) {
      (body ? axios.post(url, body) : axios.get(url))
        .then((response) => success(response))
        .catch((error) => {
          this.errorMsg = errMsg;
          this.errorDialogShow = true;
          console.log(errMsg + "\n" + error);
        });
    },
    fetchAutomations() {
      this.callApi(
        `${BASE_URL}/api/logic-script-list?company=${this.company}`,
        null,
        (response) => {
          this.automations = response.data; //JSON.parse(JSON.stringify(response.data)); // json clone
        },
        "Error happened while loading list of automations"
      );
    },
    setVisible(p) {
      this.visiblePanel = p;
    },
    addCustomSetting() {
      console.log(this.companySettings);
      if (
        this.newVariableName &&
        !this.companySettings.hasOwnProperty(this.newVariableName)
      ) {
        let newProp = {};
        newProp[this.newVariableName] = "";
        this.companySettings = Object.assign({}, this.companySettings, newProp);
      }
      this.newVariableName = "";
      this.$forceUpdate();
    },
    deleteCustomSetting(name) {
      this.$delete(this.companySettings, name);
    },
    saveSettings() {
      this.companySettings.company_domain = this.$route.params.company;
      console.log(JSON.stringify(this.companySettings));
      this.settingsBlocked = true;
      this.callApi(
        `${BASE_URL}/api/settings?company=${this.company}`,
        this.companySettings,
        (response) => {
          this.initialCompanySettings = response.data;
          this.companySettings;
          this.settingsBlocked = false;
        },
        "Error happened while saving settings"
      );
    },
    onRefreshDialogClick() {
      this.refreshTokenDialogShow = true;
    },
    refreshToken() {
      window.open(
        `${BASE_URL}/api/refresh?company=${this.company}&client_id=${this.companySettings.client_id}&client_secret=${this.companySettings.client_secret}`,
        "_blank"
      );
    },
    addAutomation() {
      let routeData = this.$router.resolve({
        name: "Automation",
        params: { company: this.$route.params.company },
      });
      window.open(routeData.href, "_blank");
    },
    deleteAutomation() {
      this.deleteClicked = true;
      axios
        .get(
          `${BASE_URL}/api/logic-script-delete?id=${this.automationToDelete.id}&company=${this.$route.params.company}`
        )
        .then((_) => {
          this.deleteAutomationDialogShow = false;
          this.fetchAutomations();
        })
        .catch((error) => {
          this.deleteAutomationDialogShow = false;
          this.errorMsg = "FAILED TO DELETE";
          this.errorDialogShow = true;
          console.log(this.errorMsg + "\n" + error);
        });
    },
    openEdit(id) {
      const url = this.$router.resolve({
        name: "Automation",
        params: { company: this.company, id: id },
        query: { edit: true },
      });
      window.open(url.href, "_blank");
    },
    openLog(id) {
      const url = this.$router.resolve({
        name: "Log",
        params: { company: this.company, id: id },
      });
      window.open(url.href, "_blank");
    },
  },
};
</script>

<style type="text/css" scoped></style>
